export default __webpack_public_path__ + "static/11003-60a30dca05668f6acf4ebf8f9d9ca586.jpg";